import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

const data = [
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
  {
    name: "",
    Finished: 0,
    Enrolled: 0,
    amt: 0,
  },
];

export default function MainChart() {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        width={500}
        height={300}
        data={data}
        margin={{
          top: 5,
          right: 30,
          left: 20,
          bottom: 5,
        }}
      >
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="name" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Bar dataKey="Enrolled" fill="#8884d8" background={{ fill: "#eee" }} />
        <Bar dataKey="Finished" fill="#5BBC8F" />
      </BarChart>
    </ResponsiveContainer>
  );
}
